__turbopack_context__.v({
  "ProductWithThreeBanner": "ProductWithThreeBanner-module__hnyZ7a__ProductWithThreeBanner",
  "banner": "ProductWithThreeBanner-module__hnyZ7a__banner",
  "banners": "ProductWithThreeBanner-module__hnyZ7a__banners",
  "body": "ProductWithThreeBanner-module__hnyZ7a__body",
  "products": "ProductWithThreeBanner-module__hnyZ7a__products",
  "right": "ProductWithThreeBanner-module__hnyZ7a__right",
  "slider": "ProductWithThreeBanner-module__hnyZ7a__slider",
  "swiper": "ProductWithThreeBanner-module__hnyZ7a__swiper",
});
